import React, { useEffect } from 'react';
import useApi from "../../hooks/useApi";
import ITableauBord from "../../models/ITableauBord";
import { useCalendrierProps } from "./calendrier";
import { TypeCalendrier } from './calendrier-interfaces';
import { add, format } from "date-fns";


function CalendrierTableauBord() {
  const { typeCalendrier, selectedTypeUnite, dateCourrante, nbColonne } = useCalendrierProps();
  const dateFin = add(dateCourrante, { [typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: nbColonne });
  const { data: tableauBordData, getData: getTableauBordData } = useApi<ITableauBord>();

  useEffect(() => {
    if (!selectedTypeUnite?.id) return;
    getTableauBordData({ customPath: `reservation/${selectedTypeUnite?.id}/tableauBord?typeCalendrier=${selectedTypeUnite?.type}&dateDebut=${format(dateCourrante, "yyyy-MM-dd")}&dateFin=${format(dateCourrante.setHours(23, 59, 59), "yyyy-MM-dd HH:mm:ss")}` });
  }, [typeCalendrier, selectedTypeUnite, dateCourrante, nbColonne])

  return (
    <div className={"calendrier-tableauBord"}>
      <div><b>{format(dateCourrante, "yyyy-MM-dd")} </b></div>
      <div style={{ backgroundColor: "#a1a1a1", width: "1px" }} />
      <div>
        <div>Unité disponible :</div>
        <div className={"vert"}>{tableauBordData?.nombreUnitesDisponible}</div>
      </div>
      <div>
        <div>Unité hors-service :</div>
        <div>{tableauBordData?.nombreUnitesHorsService}</div>
      </div>
      <div>
        <div>Arrivées :</div>
        <div>{tableauBordData?.nombreArrivees}</div>
        <div className={"bleu"}>({tableauBordData?.nombrePersonnesArrivees} personnes)</div>
      </div>
      <div>
        <div>Départs :</div>
        <div>{tableauBordData?.nombreDeparts}</div>
        <div className={"bleu"}>({tableauBordData?.nombrePersonnesDeparts} personnes)</div>
      </div>
      <div>
        <div>Nombre de Personnes :</div>
        <div>{tableauBordData?.nombrePersonnesSejour}</div>
      </div>
    </div>
  );
}

export default CalendrierTableauBord;